<template>
  <div class="sb_sub-title">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
};
</script>

<style lang="scss">
#sb_fotowand-designer {
  .sb_sub-title {
    margin-top: 0.2rem;
    color: $brand-black;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.33;
    display: none;
    @include media('>=medium-portrait') {
      display: inline-block;
    }
  }
}
</style>
